import { marker as extractTranslation } from '@colsen1991/ngx-translate-extract-marker';
import { GenderKey } from '@nk/data-entities-lib';

export const GENDER_TRANSLATIONS: Record<GenderKey, string> = {
  [GenderKey.female]: extractTranslation('common.genders.female'),
  [GenderKey.male]: extractTranslation('common.genders.male'),
  [GenderKey.other]: extractTranslation('common.genders.other'),
};
